import { Component, OnInit, Renderer2, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { profitLoss } from '@teem/app/core/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { UserService } from '@teem/services/user.service';


@Component({
    selector: 'app-profit-loss-statement',
    templateUrl: './profit-loss-statement.component.html',
    styleUrls: ['./profit-loss-statement.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProfitLossStatementComponent implements OnInit {
    // @ViewChild('datepickerGrid') datepickerGrid!: ElementRef;
    // @ViewChild('startDayInput') startDayInput!: ElementRef<HTMLInputElement>;
    // @ViewChild('endDayInput') endDayInput!: ElementRef<HTMLInputElement>;

    constructor(
        private renderer: Renderer2,
        private userService: UserService,
    ) {
        this.generateDateOptions();
    }
    periods: string[] = [];

    financialData: any[] = [];

    sectionOrder = ["revenue", "cogs", "oe"];

    fetchFinancialData(): void {
        const payload = { periods: this.comparePeriods };
        this.userService.getFinancialData(payload).subscribe(
            (response: any) => {
                if (response) {
                    this.financialData = response;

                    // Reset periods
                    this.periods = [];

                    if (this.financialData.length > 0) {
                    // Extract periods from the first category's first item
                    const firstCategory = this.financialData[0];
                        if (firstCategory.items && firstCategory.items.length > 0) {
                            this.periods = Object.keys(firstCategory.items[0].periods);
                        }
                    }
                }
            },
            error => console.error(error)
        );
    }

    ngOnInit(): void {
        this.fetchFinancialData();
    }

    ngAfterViewInit(): void {
        this.updateCalendar('period1');
        this.updateCalendar('period2');
    }
    periodState = {
        period1: {
            start: null as Date | null,
            end: null as Date | null,
            selectingEnd: false
        },
        period2: {
            start: null as Date | null,
            end: null as Date | null,
            selectingEnd: false
        }
    };

    dateOptions: { label: string, range: string }[] = [];
    currentDate = {
        period1: new Date(),
        period2: new Date()
    };
    isSelectingEndDate = false;
    selectedText: string = i18n.dashboard.select_an_option;

    activeDropdown: HTMLElement | null = null;

    selectedStartDate: Date | null = null;
    selectedEndDate: Date | null = null;


    monthNames: string[] = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];


    // popup variables
    isPopupOpen = false;
    dropdownOpen1 = true;
    dropdownOpen2 = true;
    selectedOption1 = 'Select Option';
    selectedOption2 = 'Select Option';

    comparePeriods: { period: string; label: string; start: string; end: string }[] = [];

    compareperiod = false;

    selectedStartDatePeriod1: Date | null = null;
    selectedEndDatePeriod1: Date | null = null;
    selectedStartDatePeriod2: Date | null = null;
    selectedEndDatePeriod2: Date | null = null;
    selectedTextPeriod1: string = i18n.dashboard.select_an_option;
    selectedTextPeriod2: string = i18n.dashboard.select_an_option;

    openPopup() {
        this.isPopupOpen = true;
        setTimeout(() => {
            this.updateCalendar('period1');
            this.updateCalendar('period2');
        });
    }

    closePopup() {
        this.isPopupOpen = false;
    }

    togglePopupDropdown(dropdown: number) {
        if (dropdown === 1) {
            this.dropdownOpen1 = !this.dropdownOpen1;
        } else {
            this.dropdownOpen2 = !this.dropdownOpen2;
        }
    }

    selectOption(dropdown: number, option: string) {
        if (dropdown === 1) {
            this.selectedOption1 = option;
            this.dropdownOpen1 = false;
        } else {
            this.selectedOption2 = option;
            this.dropdownOpen2 = false;
        }
    }

    hideCompare() {
        this.hideDiv('compare_period_head ', 'none');
        this.showDiv('no-compare', 'flex');
        this.hideDiv('deleteCompare ', 'none');
    }

    // compare() {
    //     this.showDiv('compare_period_head ', 'flex');
    //     this.hideDiv('no-compare', 'none');
    //     this.showDiv('deleteCompare ', 'block');

    //     if (
    //         this.selectedStartDatePeriod1 && this.selectedEndDatePeriod1 &&
    //         this.selectedStartDatePeriod2 && this.selectedEndDatePeriod2
    //     ) {
    //         this.comparePeriods = [
    //             {
    //                 period: 'period1',
    //                 label: this.selectedTextPeriod1,
    //                 start: this.selectedStartDatePeriod1.toISOString().split('T')[0],
    //                 end: this.selectedEndDatePeriod1.toISOString().split('T')[0]
    //             },
    //             {
    //                 period: 'period2',
    //                 label: this.selectedTextPeriod2,
    //                 start: this.selectedStartDatePeriod2.toISOString().split('T')[0],
    //                 end: this.selectedEndDatePeriod2.toISOString().split('T')[0]
    //             }
    //         ];
    //     }
    //     this.closePopup();
    //     this.hideCompare();
    //     this.fetchFinancialData();
    // }

    compare() {
        this.showDiv('compare_period_head', 'flex');
        this.hideDiv('no-compare', 'none');
        this.showDiv('deleteCompare', 'block');

        // Helper function to format a date as YYYY-MM-DD without timezone issues
        const formatDate = (date: Date): string => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        if (
            this.selectedStartDatePeriod1 && this.selectedEndDatePeriod1 &&
            this.selectedStartDatePeriod2 && this.selectedEndDatePeriod2
        ) {
            this.comparePeriods = [
                {
                    period: 'period1',
                    label: this.selectedTextPeriod1,
                    start: formatDate(this.selectedStartDatePeriod1),
                    end: formatDate(this.selectedEndDatePeriod1)
                },
                {
                    period: 'period2',
                    label: this.selectedTextPeriod2,
                    start: formatDate(this.selectedStartDatePeriod2),
                    end: formatDate(this.selectedEndDatePeriod2)
                }
            ];
        }

        this.closePopup();
        this.hideCompare();
        this.fetchFinancialData();
    }


    languageDetector(arabic: string, english: string): string {
        return navigator.language.startsWith('ar') ? arabic : english;
    }

    generateDateOptions() {
        const today = new Date();

        const formatDate = (date: Date) =>
            date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

        // const getPastDate = (days: number) => {
        //     const pastDate = new Date();
        //     pastDate.setDate(today.getDate() - days);
        //     return pastDate;
        // };

        const getPastDate = (days: number) => {
            const now = new Date();
            now.setDate(today.getDate() - days);
            const dayOfWeek = now.getDay(); // 0 for Sunday, 6 for Saturday
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - dayOfWeek); // Move back to Sunday
            // startOfWeek.setHours(0, 0, 0, 0); // Reset time

            // const endOfWeek = new Date(startOfWeek);
            // endOfWeek.setDate(startOfWeek.getDate() + 6); // Move forward to Saturday
            // endOfWeek.setHours(23, 59, 59, 999); // Set to end of the day

            return startOfWeek;
        }

        const getThisWeeksSaturday = (days: number) => {
            const today = new Date();
            today.setDate(today.getDate() - days);
            const dayOfWeek = today.getDay();
            const daysUntilSaturday = 6 - dayOfWeek;
            today.setDate(today.getDate() + daysUntilSaturday);
            return today;
        }

        const getMonthStart = (monthOffset: number): Date => {
            return new Date(today.getFullYear(), today.getMonth() - monthOffset, 1);
        };

        // Helper function to get the last day of a specific month (monthOffset)
        const getMonthEnd = (monthOffset: number): Date => {
            const firstDayOfMonth: Date = new Date(today.getFullYear(), today.getMonth() - monthOffset, 1);
            return new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 0);
        };

        function getYesterdayDate(): Date {
            const today: Date = new Date();
            today.setDate(today.getDate() - 1); // Subtract one day from today's date
            return today;
        }

        this.dateOptions = [
            { label: i18n.dashboard.today || "Today", range: `${formatDate(today)} - ${formatDate(today)}` },
            { label: i18n.dashboard.yesterday || "Yesterday", range: `${formatDate(getYesterdayDate())} - ${formatDate(today)}` },
            { label: i18n.dashboard.this_week || "This Week", range: `${formatDate(getPastDate(0))} - ${formatDate(getThisWeeksSaturday(0))}` },
            { label: i18n.dashboard.last_week || "Last Week", range: `${formatDate(getPastDate(7))} - ${formatDate(getThisWeeksSaturday(7))}` },
            { label: i18n.dashboard.last_two_weeks || "Last Two Weeks", range: `${formatDate(getPastDate(14))} - ${formatDate(getThisWeeksSaturday(7))}` },
            { label: i18n.dashboard.this_month || "This Month", range: `${formatDate(getMonthStart(0))} - ${formatDate(getMonthEnd(0))}` },
            { label: i18n.dashboard.last_month || "Last Month", range: `${formatDate(getMonthStart(1))} - ${formatDate(getMonthEnd(1))}` },
            { label: i18n.dashboard.last_three_month || "Last Three Months", range: `${formatDate(getMonthStart(3))} - ${formatDate(getMonthEnd(1))}` }
        ];
    }

    toggleDropdown(event: Event): void {
        const button = event.target as HTMLElement;
        const dropdownContainer = button.closest('.custom_select');
        const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
        const allDropdowns = document.querySelectorAll('.custom_select-content');
        const allContainers = document.querySelectorAll('.custom_select');

        allDropdowns.forEach((dropdown) => {
            if (dropdown !== dropdownMenu) {
                this.renderer.setStyle(dropdown, 'display', 'none');
            }
        });

        allContainers.forEach((container) => {
            if (container !== dropdownContainer) {
                this.renderer.removeClass(container, 'active');
            }
        });

        const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

        this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

        if (isDropdownVisible) {
            this.renderer.removeClass(dropdownContainer, 'active');
        } else {
            this.renderer.addClass(dropdownContainer, 'active');
        }
    }

    downloadPDF() {
        const lang = document.documentElement.lang;
        const params = new URLSearchParams();
        this.comparePeriods.forEach((period, index) => {
            params.append(`periods[${index}][label]`, period.label);
            params.append(`periods[${index}][start]`, period.start);
            params.append(`periods[${index}][end]`, period.end);
        });

        const url = `${profitLoss.download_pdf}/${lang}?${params.toString()}`;
        window.open(url, '_blank');
    }

    downloadExcel() {
        const lang = document.documentElement.lang;
        const params = new URLSearchParams();
        this.comparePeriods.forEach((period, index) => {
            params.append(`periods[${index}][label]`, period.label);
            params.append(`periods[${index}][start]`, period.start);
            params.append(`periods[${index}][end]`, period.end);
        });

        const url = `${profitLoss.download_excel}/${lang}?${params.toString()}`;
        window.open(url, '_blank');
    }

    togglePeriodDropdown(event: Event, period: string): void {
        const button = event.target as HTMLElement;
        const dropdownContainer = button.closest('.custom_select') as HTMLElement;
        const dropdownMenu = dropdownContainer?.querySelector('.custom_select-content') as HTMLElement;
        const allDropdowns = document.querySelectorAll('.custom_select-content');
        const allContainers = document.querySelectorAll('.custom_select');

        if (!dropdownMenu || !dropdownContainer) return;

        // Close all other dropdowns except the one being clicked
        allDropdowns.forEach((dropdown) => {
            if (dropdown !== dropdownMenu) {
                this.renderer.setStyle(dropdown as HTMLElement, 'display', 'none');
            }
        });

        allContainers.forEach((container) => {
            if (container !== dropdownContainer) {
                this.renderer.removeClass(container, 'active');
            }
        });

        // Toggle visibility for the selected dropdown
        const isDropdownVisible = dropdownMenu.style.display === 'block';

        if (isDropdownVisible) {
            this.renderer.setStyle(dropdownMenu, 'display', 'none');
            this.renderer.removeClass(dropdownContainer, 'active');
        } else {
            this.renderer.setStyle(dropdownMenu, 'display', 'block');
            this.renderer.addClass(dropdownContainer, 'active');
        }
    }

    hideDiv(className: string, action: 'none' | 'flex' | 'block') {
        const elements = document.querySelectorAll(`.${className}`);
        elements.forEach((element) => {
            this.renderer.setStyle(element, 'display', action);
        });
    }

    showDiv(className: string, action: 'none' | 'flex' | 'block') {
        const elements = document.querySelectorAll(`.${className}`);
        elements.forEach((element) => {
            this.renderer.setStyle(element, 'display', 'flex'); // Always sets to flex when showing
        });
    }

    // applyDateRange(className: string) {
    //     if (this.selectedStartDate && this.selectedEndDate) {
    //         this.cancelDataPicker(className);
    //     }
    // }
    applyDateRange(period: 'period1' | 'period2') {
        const state = this.periodState[period];

        if (!state.start || !state.end) {
            return; // do nothing if range incomplete
        }

        // Update displayed selected text
        const start = state.start.toLocaleDateString('en-US');
        const end = state.end.toLocaleDateString('en-US');
        console.log(new Date(state.start));
        console.log(end);
        if (period === 'period1') {
            this.selectedTextPeriod1 = `${start} - ${end}`;
            this.selectedStartDatePeriod1 = new Date(state.start);
            this.selectedEndDatePeriod1 = new Date(state.end);
        } else {
            this.selectedTextPeriod2 = `${start} - ${end}`;
            this.selectedStartDatePeriod2 = new Date(state.start);
            this.selectedEndDatePeriod2 = new Date(state.end);
        }

        this.cancelDataPicker(period);
    }


    cancelDataPicker(className: string) {
        document.getElementById('custom_datepicker-popup-'+className)?.classList.add('hidden');
    }

    openDataPicker(className: 'period1' | 'period2') {
        this.updateCalendar(className);
        document.getElementById('custom_datepicker-popup-'+className)?.classList.remove('hidden');
    }
    
    // updateCalendar() {
    //     const grid = this.datepickerGrid.nativeElement;
    //     grid.innerHTML = '';

    //     const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    //     const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
    //     const daysInMonth = lastDay.getDate();
    //     const startDay = firstDay.getDay() //firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;

    //     for (let i = 0; i < startDay; i++) {
    //         const emptyCell = document.createElement('div');
    //         grid.appendChild(emptyCell);
    //     }

    //     for (let day = 1; day <= daysInMonth; day++) {
    //         const dayElement = document.createElement('div');
    //         dayElement.textContent = `${day}`;
    //         dayElement.classList.add('calendar-day');

    //         dayElement.addEventListener('click', () => this.handleDateSelection(day, dayElement));

    //         grid.appendChild(dayElement);
    //     }

    //     this.highlightRange();
    // }

    updateCalendar(period: 'period1' | 'period2') {
        const popup = document.getElementById(`custom_datepicker-popup-${period}`);
        if (!popup) return;

        const grid = popup.querySelector('.custom_datepicker-grid') as HTMLElement;
        if (!grid) return;

        grid.innerHTML = '';

        // const year = this.currentDate.getFullYear();
        // const month = this.currentDate.getMonth();
        const year = this.currentDate[period].getFullYear();
        const month = this.currentDate[period].getMonth();

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);

        const daysInMonth = lastDay.getDate();
        const startDay = firstDay.getDay();

        // empty cells
        for (let i = 0; i < startDay; i++) {
            const empty = document.createElement('div');
            empty.classList.add('empty-day');
            grid.appendChild(empty);
        }

        // days
        for (let day = 1; day <= daysInMonth; day++) {
            const el = document.createElement('div');
            el.classList.add('calendar-day');
            el.textContent = String(day);

            el.addEventListener('click', () =>
                this.handleDateSelection(day, el, period)
            );

            grid.appendChild(el);
        }

        this.highlightRange(period);
    }


    // handleDateSelection(day: number, element: HTMLElement) {
    //     const selectedDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day);

    //     if (!this.selectedStartDate || (this.selectedStartDate && this.selectedEndDate)) {
    //         this.selectedStartDate = selectedDate;
    //         this.selectedEndDate = null;
    //         this.isSelectingEndDate = true;
    //         this.clearSelection();
    //         element.classList.add('selected-date');
    //     } else if (this.isSelectingEndDate) {
    //         if (selectedDate < this.selectedStartDate) {
    //             this.selectedEndDate = this.selectedStartDate;
    //             this.selectedStartDate = selectedDate;
    //         } else {
    //             this.selectedEndDate = selectedDate;
    //         }
    //         this.isSelectingEndDate = false;
    //     }

    //     this.highlightRange();
    //     this.updateInputs();
    // }

    // highlightRange() {
    //     const grid = this.datepickerGrid.nativeElement;
    //     const days = grid.querySelectorAll('.calendar-day');

    //     days.forEach((dayElement: any) => {
    //         const dayNumber = parseInt(dayElement.textContent, 10);
    //         const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), dayNumber);

    //         dayElement.classList.remove('selected-range', 'selected-date');

    //         if (this.selectedStartDate && date.getTime() === this.selectedStartDate.getTime()) {
    //             dayElement.classList.add('selected-date');
    //         }

    //         if (this.selectedEndDate && date.getTime() === this.selectedEndDate.getTime()) {
    //             dayElement.classList.add('selected-date');
    //         }

    //         if (this.selectedStartDate && this.selectedEndDate &&
    //             date > this.selectedStartDate && date < this.selectedEndDate) {
    //             dayElement.classList.add('selected-range');
    //         }
    //     });
    // }

    // updateInputs() {
    //     if (this.selectedStartDate) {
    //         this.startDayInput.nativeElement.value = this.selectedStartDate.toLocaleDateString('en-US');
    //     }
    //     if (this.selectedEndDate) {
    //         this.endDayInput.nativeElement.value = this.selectedEndDate.toLocaleDateString('en-US');
    //     }
    // }

    handleDateSelection(
        day: number,
        element: HTMLElement,
        period: 'period1' | 'period2'
    ) {
        const selectedDate = new Date(
            // this.currentDate.getFullYear(),
            // this.currentDate.getMonth(),
            this.currentDate[period].getFullYear(),
            this.currentDate[period].getMonth(),
            day
        );

        const state = this.periodState[period];

        if (!state.start || state.end) {
            state.start = selectedDate;
            state.end = null;
            this.clearSelection(period);
            element.classList.add('selected-date');
        } else {
            if (selectedDate < state.start) {
                state.end = state.start;
                state.start = selectedDate;
            } else {
                state.end = selectedDate;
            }
        }

        this.highlightRange(period);
        this.updateInputs(period);
    }

    highlightRange(period: 'period1' | 'period2') {
        const grid = document.querySelector(
            `#custom_datepicker-popup-${period} .custom_datepicker-grid`
        ) as HTMLElement;

        if (!grid) return;

        const days = grid.querySelectorAll('.calendar-day');
        const state = this.periodState[period];

        const isSameDate = (a: Date, b: Date) =>
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate();

        days.forEach((dayEl) => {
            const day = Number(dayEl.textContent);
            const cellDate = new Date(
                this.currentDate[period].getFullYear(),
                this.currentDate[period].getMonth(),
                day
            );

            dayEl.classList.remove('selected-date', 'selected-range');

            if (state.start && isSameDate(cellDate, state.start)) {
                dayEl.classList.add('selected-date');
            }

            if (state.end && isSameDate(cellDate, state.end)) {
                dayEl.classList.add('selected-date');
            }

            if (state.start && state.end && cellDate > state.start && cellDate < state.end) {
                dayEl.classList.add('selected-range');
            }
        });
    }

    // changeMonth(step: number, period: 'period1' | 'period2') {
    //     console.log('change Month')
    //     this.currentDate[period].setMonth(
    //         this.currentDate[period].getMonth() + step
    //     );
    //     this.updateCalendar(period);
    // }
    changeMonth(step: number, period: 'period1' | 'period2') {
        const current = this.currentDate[period];

        this.currentDate[period] = new Date(
            current.getFullYear(),
            current.getMonth() + step,
            1
        );

        this.updateCalendar(period);
    }

    updateInputs(period: 'period1' | 'period2') {
        const popup = document.getElementById(`custom_datepicker-popup-${period}`);
        if (!popup) return;

        const inputs = popup.querySelectorAll('input');
        const { start, end } = this.periodState[period];

        if (inputs[0] && start) {
            inputs[0].value = start.toLocaleDateString('en-US');
        }

        if (inputs[1] && end) {
            inputs[1].value = end.toLocaleDateString('en-US');
        }
    }

    // clearSelection() {
    //     const grid = this.datepickerGrid.nativeElement;
    //     grid.querySelectorAll('.calendar-day').forEach((day: any) => {
    //         day.classList.remove('selected-date', 'selected-range');
    //     });
    // }

    clearSelection(period: 'period1' | 'period2') {
        const popup = document.getElementById(`custom_datepicker-popup-${period}`);
        if (!popup) return;

        popup
            .querySelectorAll('.calendar-day')
            .forEach(el =>
                el.classList.remove('selected-date', 'selected-range')
            );
    }


    selectItem(event: Event, option: { label: string, range: string }): void {
        const selectedElement = event.target as HTMLElement;
        this.selectedText = selectedElement.innerText.trim();

        if (option) {

            const [startDateStr, endDateStr] = option.range.split(' - ');

            const startDate = new Date(startDateStr);
            const endDate = new Date(endDateStr);

            if (startDate && endDate && startDate <= endDate) {
                this.selectedStartDate = startDate;
                this.selectedEndDate = endDate;
            }
        }

        const activeDropdowns = document.querySelectorAll('.custom_select.active');
        activeDropdowns.forEach((dropdown) => {
            this.renderer.removeClass(dropdown, 'active');
            const dropdownMenu = dropdown.querySelector('.custom_select-content') as HTMLElement;
            if (dropdownMenu) {
                this.renderer.setStyle(dropdownMenu, 'display', 'none');
            }
        });


        this.activeDropdown = null;
    }

    selectPeriods(event: Event, option: { label: string, range: string }, period: string): void {
        const [startDateStr, endDateStr] = option.range.split(' - ');
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        console.log(startDate)
        console.log(endDate)
        if (period === 'period1') {
            this.selectedTextPeriod1 = option.label;
            this.selectedStartDatePeriod1 = startDate;
            this.selectedEndDatePeriod1 = endDate;
        } else {
            this.selectedTextPeriod2 = option.label;
            this.selectedStartDatePeriod2 = startDate;
            this.selectedEndDatePeriod2 = endDate;
        }

        const activeDropdowns = document.querySelectorAll('.custom_select.active'); activeDropdowns.forEach((dropdown) => { this.renderer.removeClass(dropdown, 'active'); const dropdownMenu = dropdown.querySelector('.custom_select-content') as HTMLElement; if (dropdownMenu) { this.renderer.setStyle(dropdownMenu, 'display', 'none'); } });

        this.activeDropdown = null;
        this.fetchFinancialData();

    }

    

    toggleSubDescriptions(item: any) {
        item.showSubDescriptions = !item.showSubDescriptions;
    }

    isCompareActive: boolean = false;

    datePickerOptions = [
        { label: 'Last 7 days', range: '01/10/2025 - 07/10/2025' },
        { label: 'Last Month', range: '01/09/2025 - 30/09/2025' },
        // ... add more
    ];

    toggleComparePeriods() {
        this.isCompareActive = true;
    }

    hidePickerCompare() {
        this.isCompareActive = false;
        this.selectedTextPeriod1 = 'Select period 1';
        this.selectedTextPeriod2 = 'Select period 2';
    }

    selectPickerPeriods(event: any, option: any, period: string) {
        if (period === 'period1') {
            this.selectedTextPeriod1 = option.label;
        } else {
            this.selectedTextPeriod2 = option.label;
        }
    }
}
